import { render } from "./AutomationFooter.vue?vue&type=template&id=94cc1d3c"
import script from "./AutomationFooter.vue?vue&type=script&lang=js"
export * from "./AutomationFooter.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./AutomationFooter.vue?vue&type=style&index=0&id=94cc1d3c&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__